module.exports = __webpack_public_path__ + "img/userRes_a.d2a9936d.png";